<template>
    <div class="licitacao-esclarecimento-impugnacao">
        <modal-criar-esclarecimento-impugnacao-servidor
            v-if="exibirModalSolicitacao"
            :exibir="exibirModalSolicitacao"
            :tipo="tipoSelecionado"
            :licitacaoId="licitacaoId"
            max-width="700" class="modal-criar-esc-imp"
            @buscarEsclarecimentoImpugnacoes="buscarSolicitacoes"
            @fecharModal="fecharModalInserirEsclarecimentoImpugnacao"/>
        <div class="inserir-esclarecimento-impugnacao" v-if="licitacao.publicado">
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">
                        Inserir
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile
                        v-for="(tipo) in tiposAnexoFornecedor"
                        :key="tipo.chave"
                        @click="abrirModalSolicitacao(tipo.chave)"
                    >
                        <v-list-tile-title>{{ tipo.label }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </div>
        <licitacao-esclarecimento-impugnacao-vazio v-if="naoPossuiEsclarecimentoImpugnacao"/>
        <div v-else>
            <licitacao-esclarecimento-tabela :esclarecimentos="esclarecimentosDados"
                                             @buscarEsclarecimentos="buscarEsclarecimentosLicitacao"/>
            <licitacao-impugnacao-tabela :impugnacoes="impugnacaoDados"
                                         @buscarImpugnacoes="buscarImpugnacaoLicitacao"/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes, tiposAnexoFornecedor} from '@/commons/constants'
import LicitacaoEsclarecimentoImpugnacaoVazio from './LicitacaoEsclarecimentoImpugnacaoVazio'
import LicitacaoEsclarecimentoTabela from './LicitacaoEsclarecimentoTabela'
import LicitacaoImpugnacaoTabela from './LicitacaoImpugnacaoTabela'
import ModalCriarEsclarecimentoImpugnacaoServidor
    from "@/views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/Modal/ModalCriarEsclarecimentoImpugnacaoServidor.vue";

export default {
    name: 'LicitacaoEsclarecimentoImpugnacao',
    components: {
        ModalCriarEsclarecimentoImpugnacaoServidor,
        LicitacaoImpugnacaoTabela,
        LicitacaoEsclarecimentoTabela,
        LicitacaoEsclarecimentoImpugnacaoVazio
    },
    data() {
        return {
            esclarecimentosDados: [],
            impugnacaoDados: [],
            licitacaoId: null,
            tipoSelecionado: null,
            exibirModalSolicitacao: false,
        }
    },
    computed: {
        ...mapState(['licitacao']),
        tiposAnexoFornecedor() {
            return tiposAnexoFornecedor
        },
        naoPossuiEsclarecimentoImpugnacao() {
            return (!this.esclarecimentosDados || this.esclarecimentosDados.length === 0) && (!this.impugnacaoDados || this.impugnacaoDados.length === 0)
        }
    },
    async mounted() {
        this.setLicitacaoId()
        await this.buscarImpugnacaoLicitacao()
        await this.buscarEsclarecimentosLicitacao()
    },
    methods: {
        ...mapActions([
            actionTypes.BUSCAR_ESCLARECIMENTOS,
            actionTypes.BUSCAR_IMPUGNACOES
        ]),
        async buscarEsclarecimentosLicitacao() {
            this.setMensagemLoading('Atualizando a listagem de esclarecimentos...')
            const resposta = await this.buscarEsclarecimentos(this.licitacaoId)
            if (resposta) {
                this.esclarecimentosDados = resposta.esclarecimentos
            }
        },
        async buscarImpugnacaoLicitacao() {
            this.setMensagemLoading('Atualizando a listagem de impugnações...')
            const resposta = await this.buscarImpugnacoes(this.licitacaoId)
            if (resposta) {
                this.impugnacaoDados = resposta.impugnacoes
            }
        },
        setLicitacaoId() {
            this.licitacaoId = Number(this.$route.params.id)
        },
        abrirModalSolicitacao(tipo) {
            this.tipoSelecionado = tipo
            this.exibirModalSolicitacao = true
        },
        fecharModalInserirEsclarecimentoImpugnacao() {
            this.tipoSelecionado = null
            this.exibirModalSolicitacao = false
        },
        async buscarSolicitacoes() {
            await this.buscarImpugnacaoLicitacao()
            await this.buscarEsclarecimentosLicitacao()
            this.fecharModalInserirEsclarecimentoImpugnacao()
        }
    }
}
</script>

<style scoped lang="stylus">
.licitacao-esclarecimento-impugnacao
    min-height 59vh

</style>
